import { ChangeEvent, useState, KeyboardEvent, useRef, useEffect, forwardRef } from 'react';

export type ChatBarProps = {
  textareaRef: React.RefObject<HTMLTextAreaElement>;
  location: string;
  addMessage: (message: string, location: string) => void;
  loading?: boolean;
  onResize?: () => void;
};

export function ChatBar(props: ChatBarProps) {
  const { loading, addMessage, location, textareaRef, onResize } = props;
  const [input, setInput] = useState('');

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'; // Reset the height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set the height to scroll height

      if (onResize) {
        onResize();
      }
    }
  }, [input, textareaRef, onResize]);

  return (
    <div className="input flex">
      <textarea
        ref={textareaRef}
        className={`flex-grow p-2 text-white rounded-l-lg resize-none ${
          loading ? 'cursor-not-allowed bg-gray-800' : 'cursor-text bg-gray-700'
        }`}
        disabled={loading}
        placeholder={loading ? 'Loading...' : 'Ask a question...'}
        rows={1}
        value={input}
        onChange={(e) => {
          setInput(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !loading) {
            addMessage(input, location);
            setInput('');
          }
        }}
      />
      <button
        className={`text-black p-2 rounded-l-none rounded-r-lg${
          loading ? ' cursor-not-allowed bg-gray-800' : ' cursor-pointer bg-white'
        }`}
        disabled={loading}
        onClick={() => {
          if (!loading) {
            addMessage(input, location);
            setInput('');
          }
        }}
      >
        {'->'}
      </button>
    </div>
  );
}
